import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/accountsFinancialPosition'
import { getAccountsFinancialPosition as getAccountsFinancialPositionService } from 'services'

export const {
  ACCOUNTS_POSITION_ERROR,
  ACCOUNTS_POSITION_REQUEST,
  ACCOUNTS_POSITION_SUCCESS
} = ACTION_TYPES

export function *getAccountsFinancialPosition(payload) {
  try {
    const response = yield call(getAccountsFinancialPositionService, payload)
    yield put({ type: ACCOUNTS_POSITION_SUCCESS, payload: response.data })
  } catch (err) {
    yield put({ type: ACCOUNTS_POSITION_ERROR, payload: err })
  }
}

export default function *watchAccountsFinancialPosition() {
  yield takeLatest(ACCOUNTS_POSITION_REQUEST, getAccountsFinancialPosition)
}
